import { render } from "./navigationComponent.vue?vue&type=template&id=d96e70b0&scoped=true"
import script from "./navigationComponent.vue?vue&type=script&lang=js"
export * from "./navigationComponent.vue?vue&type=script&lang=js"

import "./navigationComponent.vue?vue&type=style&index=0&id=d96e70b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96e70b0"]])

export default __exports__